import { CompanyEntity } from "../Company/CompanyEntity"
import { AddtionalMemory } from "./AddtionalMemory"
import { AwardMemory } from "./AwardMemory"
import { CategoryMemory } from "./CategoryMemory"
import { CustomerMemory as CostumerMemory } from "./CustomerMemory"
import { DrinksMemory } from "./DrinksMemory"
import { EmployeeMemory } from "./EmployeeMemory"
import { ExtraServiceMemory } from "./ExtraServiceMemory"
import { MealsMemory } from "./MealsMemory"
import { MemoryTables } from "./TablesMemory"
import { OrderMemory } from "./OrderMemory"
import { PromotionsMemory } from "./PromotionsMemory"
import { DeliveryMemory } from "./DeliveryMemory"
import { CourierMemory } from "./CourierMemory"
import { CouponMemory } from "./CouponMemory"
import { TutorialMemory } from "./TutorialMemory"
import { ComboMemory } from "./ComboMemory"
import { SelectionMemory } from "./SelectionMemory"
import { NoticeMemory } from "./NoticeMemory"
import { ManualExternalOrderMemory } from "./ManualExternalOrderMemory"
import { AdminEmployeeMemory } from "./AdminEmployeeMemory"

export let employeeMemory = new EmployeeMemory()

export let adminEmployeeMemory = new AdminEmployeeMemory()

export let extraServiceMemory = new ExtraServiceMemory()

export let promotionsMemory = new PromotionsMemory()

export let awardMemory = new AwardMemory()

export let mealsMemory = new MealsMemory()

export let categoryMemory = new CategoryMemory()

export let addtionalMemory = new AddtionalMemory()

export let drinksMemory = new DrinksMemory()

export let tableMemory = new MemoryTables()

export let orderMemory = new OrderMemory()

export let companyMemory = new CompanyEntity({})

export let customerMemory = new CostumerMemory()

export let deliveryMemory = new DeliveryMemory()

export let courierMemory = new CourierMemory()

export let couponMemory = new CouponMemory()

export let tutorialMemory = new TutorialMemory()

export let comboMemory = new ComboMemory()

export let selectionMemory = new SelectionMemory()

export let noticeMemory = new NoticeMemory()

export let manualExternalOrderMemory = new ManualExternalOrderMemory()
